// Écran 4 — les portails : l'agenda des 14 prochains jours, jour par jour.

import type { Categorie, JourPortail, PortailOuvert } from '@alfred/shared';
import type { PropsEcran } from '../App';
import { EnTeteRetour, Icone, Nav } from '../components';
import { compteARebours, jjmm, jourCourt } from '../lib/format';
import { VOCAB } from '../lib/theme';

const ETIQUETTES: Record<Categorie, string> = {
  sport: 'SPORT', maison: 'MAISON', perso: 'PERSO', sante: 'SANTÉ', famille: 'FAMILLE',
  admin: 'ADMIN', voiture: 'VOITURE', pro: 'PRO', agenda: 'AGENDA', autre: 'AUTRE',
};

export function Portails({ etat }: PropsEcran) {
  return <VuePortails date={etat.date} ouverts={etat.ouverts} jours={etat.portails} />;
}

/** La vue seule : servie par l'état Santé (Portails) ou par l'agenda d'un membre sans ce module (Agenda). */
export function VuePortails({ date, ouverts, jours, sante = true }: { date: string; ouverts: PortailOuvert[]; jours: JourPortail[]; sante?: boolean }) {
  return (
    <main className="ecran avec-nav">
      <EnTeteRetour titre={VOCAB.portails} droite="14 J" />
      <ListePortails date={date} ouverts={ouverts} jours={jours} />
      <Nav actif="portails" sante={sante} />
    </main>
  );
}

/** Les portails ouverts puis les jours : l'écran Portails, et la colonne du tableau de bord sur le bureau. */
export function ListePortails({ date, ouverts, jours }: { date: string; ouverts: PortailOuvert[]; jours: JourPortail[] }) {
  return (
    <>
      {ouverts.map((o) => (
        <div key={o.titre} className="ouvert">
          <span className="accent" style={{ display: 'flex' }}><Icone nom="portail" taille={26} /></span>
          <span style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', gap: 1 }}>
            <span className="etiquette">{VOCAB.portailOuvert}</span>
            <span style={{ fontSize: 14, fontWeight: 600 }}>{o.titre}</span>
          </span>
          <span className="mono muted" style={{ fontSize: 11, textAlign: 'right' }}>fin {jjmm(o.fin)}</span>
        </div>
      ))}

      {jours.length === 0 && <p className="message muted">[Aucun portail dans les 14 prochains jours]</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {jours.map((j) => (
          <div key={j.jour} className="jour">
            <div className="col">
              <b style={{ color: j.jour === date ? 'var(--sys-warn)' : undefined }}>{jourCourt(j.jour)}</b>
              <small>{compteARebours(date, j.jour)}</small>
            </div>
            <div className="items">
              {j.items.map((i, k) => (
                // Un événement iCloud garde la couleur et le nom de son calendrier.
                <div key={i.titre + k} className={`evt cat-${i.categorie}`} style={i.couleur ? { color: i.couleur } : undefined}>
                  <span className="losange" />
                  <span className="t">{i.heure ? `${i.heure} · ` : ''}{i.titre}{i.detail ? ` (${i.detail})` : ''}</span>
                  <span className="tag">{i.etiquette ?? ETIQUETTES[i.categorie]}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
